import React from "react";
import { FaBookReader, FaCoffee } from "react-icons/fa";
import { hero } from "../../assets/images";
import AboutUsBtn from "../buttons/AboutUsBtn";
import { Link } from "react-scroll";

const AboutUs = () => {
  return (
    <section
      id="about"
      className="w-full py-16 lg:py-24 bg-gray-50 font-titleFont"
      aria-labelledby="about-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="flex flex-col gap-8 animate-fade-in-up">
            <div className="flex flex-col gap-2">
              <h2
                id="about-heading"
                className="text-sm font-bold tracking-widest text-designColor uppercase"
              >
                About Our Mock API
              </h2>
              <h3 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 leading-[1.2]">
                Fake Store API
              </h3>
            </div>

            <p className="text-lg text-gray-600 max-w-xl leading-relaxed font-bodyFont">
              <strong>Fake Store API</strong> is a free, reliable REST API
              designed specifically for frontend developers, UX/UI designers,
              and students to streamline e-commerce prototyping. Stop wasting
              time building backend services from scratch and start fetching
              realistic JSON data instantly.
            </p>

            <ul className="list-disc list-inside text-gray-600 space-y-3 font-bodyFont text-lg">
              <li>
                Access 200+ products, 500+ orders, and detailed user profiles.
              </li>
              <li>Test shopping carts, categories, wishlists, and payments.</li>
              <li>
                Perfect for tutorials, live demos, and rapid MVP development.
              </li>
              <li>
                <strong>Zero authentication required</strong>—start instantly!
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <a
                href="https://buymeacoffee.com/reactbd/extras"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get Fake Store API Source Code on Buy Me a Coffee"
                className="w-full sm:w-auto"
              >
                <AboutUsBtn
                  icon={<FaCoffee className="text-xl" />}
                  title="Get Source Code"
                />
              </a>

              <Link
                to="docs"
                smooth={true}
                offset={-80}
                duration={500}
                aria-label="Read Fake Store API Documentation"
                className="w-full sm:w-auto cursor-pointer"
              >
                <AboutUsBtn
                  icon={<FaBookReader className="text-xl" />}
                  title="Read API Docs"
                />
              </Link>
            </div>
          </div>

          <div className="flex lg:justify-end relative group animate-fade-in-up animation-delay-300 w-full h-full items-center">
            <div className="absolute -inset-2 bg-gradient-to-r from-designColor/30 to-primeColor/30 rounded-3xl blur-xl opacity-50 group-hover:opacity-100 transition duration-1000 group-hover:duration-500"></div>
            <img
              className="relative w-full max-w-[600px] rounded-2xl shadow-2xl object-cover border-4 border-white transform transition-transform duration-700 group-hover:scale-[1.02]"
              src={hero}
              alt="Visualization of REST API architecture and JSON data structures for e-commerce developers"
              width="600"
              height="500"
              decoding="async"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
